module.exports = __webpack_public_path__ + "img/user_WuBo.9b0b40ec.png";